export default {
    1: {
        data: [
            {
                category: "两大、战略性、支柱产业",
                cluster: "智能网联与新能源汽车",
                enterprise: "广汽丰田、小马智行、合创汽车",
                goal: "2025年总产能突破125万辆，规模以上工业总产值力争达到3000亿元，基本形成世界级智能网联与新能源汽车创新集群",
                id: 1
            },
            {
                category: "两大、战略性、支柱产业",
                cluster: "现代高端装备",
                enterprise: "广船国际、黄埔文冲、东方重机、三菱重工、海瑞克",
                goal: "2025年总产值超过500亿元，建成具有较强国内影响力的装备制造集群",
                id: 2
            },
            {
                category: "五大、战略性、新兴产业",
                cluster: "人工智能",
                enterprise: "小马智行、云从科技、科大讯飞",
                goal: "聚焦智能传感器、神经网络芯片、智能机器人、5G网络技术等产业",
                id: 3
            },
            {
                category: "五大、战略性、新兴产业",
                cluster: "半导体与集成电路",
                enterprise: "南砂晶圆、晶科电子、联晶智能、芯聚能、安捷利",
                goal: "着重解决“缺芯少核”问题，打造“产业链条完整、原始创新能力领先、共性技术平台健全”的第三代半导体应用创新示范区和产业集聚区",
                id: 4
            },
            {
                category: "五大战略性新兴产业",
                cluster: "生物医药与健康、（含高端医疗器械）",
                enterprise: "一品红药业、南沙龙沙",
                goal: "2025年产值规模突破300亿元，形成一批全国知名的拳头产品和领军企业，助力粤港澳大湾区生物医药与健康产业转型升级",
                id: 5
            },
            {
                category: "五大、战略性、新兴产业",
                cluster: "新材料",
                enterprise: "沙伯、巴斯夫",
                goal: "打造特色鲜明的新材料产业集群，产值规模突破300亿元",
                id: 6
            },
            {
                category: "五大、战略性、新兴产业",
                cluster: "新能源与节能环保",
                enterprise: "广钢气体",
                goal: "打造具有较强竞争力的新能源与节能环保产业集群，到2025年规模突破300亿元",
                id: 7
            },
            {
                category: "未来领域",
                cluster: "海洋经济",
                enterprise: "冷泉生态系统研究装置、南方海洋科学与工程省实验室（广州）等创新平台",
                goal: "优化提升海洋船舶、海工装备等优势产业，培育壮大海洋生物、海洋电子信息、新型海洋材料等新兴产业",
                id: 8
            },
            {
                category: "未来领域",
                cluster: "空天经济",
                enterprise: "中科宇航、时空探索科技",
                goal: "积极探索运载火箭、卫星等空天领域，形成集研制、生产、发射和应用于一体的全产业链布局，在空天经济探索方面走在全国前列",
                id: 9
            }
        ],
        title: "“2+5+2”先进制造业体系",
        columns: [
            {
                title: "类别",
                dataIndex: "category",
                customRender: (value, _, index) => {

                    const obj = {
                        children: value,
                        attrs: {},
                        style: {
                            color: "#45D7F4",
                            fontWeight: "bold"
                        }
                    };

                    if ([0, 7].includes(index)) {
                        obj.attrs.rowSpan = 2;
                    }

                    if (index === 2) {
                        obj.attrs.rowSpan = 5;
                    }

                    if (index === 3) {
                        obj.attrs.rowSpan = 3;
                    }

                    if ([1, 3, 4, 5, 6, 8].includes(index)) {
                        obj.attrs.rowSpan = 0;
                    }

                    return obj;
                }
            },
            {
                title: "产业",
                dataIndex: "cluster",
                scopedSlots: { 
                    customRender: 'cluster' 
                }
            },
            {
                title: "代表企业",
                dataIndex: "enterprise",
                scopedSlots: { 
                    customRender: 'enterprise' 
                }
            },
            {
                title: "目标/方向",
                dataIndex: "goal",
                scopedSlots: { 
                    customRender: 'goal' 
                }
            },
        ]
    },
    2: {
        data: [
            {
                category1: "一城一园",
                name: "南沙科学城",
                id: 1
            },
            {
                category1: "一城一园",
                name: "明珠科学园",
                id: 2
            },
            {
                category1: "省实验室",
                name: "南方海洋科学与工程省实验室（广州）",
                id: 3
            },
            {
                category1: "重大科技基础设施",
                name: "冷泉生态系统研究装置",
                id: 4
            },
            {
                category1: "重大科技基础设施",
                name: "动态宽域高超声速风洞",
                id: 5
            },
            {
                category1: "重大科技基础设施",
                name: "极端海洋动态过程多尺度自主观测科考设施",
                id: 6
            },
            {
                category1: "高水平研究平台",
                name: "香港科技大学（广州）",
                id: 7
            },
            {
                category1: "高水平研究平台",
                name: "中国科学院大学广州学院",
                id: 8
            },
            {
                category1: "高水平研究平台",
                name: "上海海事大学湾区研究生院",
                id: 9
            },
            // {
            //     category1: "高水平研究平台",
            //     name: "广东海洋大学（南沙）研究生院",
            //     id: 10
            // },
            {
                category1: "高水平研究平台",
                name: "广州超算中心南沙分中心",
                id: 10
            },
            {
                category1: "高水平研究平台",
                name: "南方海洋科学与工程广东省实验室（广州）、（新型地球物理综合科学考察船）",
                id: 11
            },
            {
                category1: "高水平研究平台",
                name: "中科院南海海洋研究所",
                id: 12
            },
            {
                category1: "高水平研究平台",
                name: "广东空天科技研究院",
                id: 13
            },
            {
                category1: "高水平研究平台",
                name: "广东智能无人系统研究院",
                id: 14
            },
            {
                category1: "高水平研究平台",
                name: "南海生态环境工程创新研究院",
                id: 15
            },
            {
                category1: "高水平研究平台",
                name: "广州海洋地质调查局深海科创中心、（天然气水合物钻采船）",
                id: 16
            }
        ],
        title: "“1+1+3+N”高端创新平台体系",
        columns: [
            {
                title: "类别",
                dataIndex: "category1",
                customRender: (value, _, index) => {

                    const obj = {
                        children: value,
                        attrs: {},
                        style: {
                            color: "#45D7F4",
                            fontWeight: "bold"
                        }
                    };

                    if (index === 0) {
                        obj.attrs.rowSpan = 2;
                    }

                    if (index === 3) {
                        obj.attrs.rowSpan = 3;
                    }

                    if (index === 6) {
                        obj.attrs.rowSpan = 11;
                    }

                    if ([1, 4, 5, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16].includes(index)) {
                        obj.attrs.rowSpan = 0;
                    }

                    return obj;
                }
            },
            {
                title: "创新平台",
                dataIndex: "name",
                scopedSlots: { 
                    customRender: 'name' 
                }
            }
        ]
    }
};